import React from 'react';
import Button from '../../components/Button';
import InputBox from '../../components/InputBoxWithoutCheck';
import Dropdown from '../../components/Dropdown';
import bulkOnboardJobseekers from '../../services/bulkOnboardJobseekers';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import user from '../../store/user';
import './styles.scss';

export default class JobseekerBulkOnboard extends React.Component {
    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
        this.state = {
            file: null,
            source: '',
            action: 'register',
            loader: false,
            error: null
        };
    }

    fileChangeHandler(ev) {
        if (ev.target.files.length > 0) {
            const file = ev.target.files[0];
            const fileName = file.name;
            const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();

            if (extension !== '.xlsx') {
                this.setState({ file: null, error: 'Only .xlsx files are allowed.' });
                ev.target.value = '';
                return;
            }

            this.setState({ file: file, error: null });
        }
    }

    onSourceChange(ev) {
        this.setState({ source: ev.target.value });
    }

    onActionChange(ev) {
        this.setState({ action: ev.target.value });
    }

    async submit() {
        const { file, source, action } = this.state;

        this.setState({ error: null });

        if (!source.trim()) {
            return this.setState({ error: 'Please provide a source name.' });
        }

        if (!file) {
            return this.setState({ error: 'Please select a file to upload.' });
        }

        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('source', source);
            formData.append('action', action);

            const profile = await user.getProfile();
            const adminId = profile.id;


            if (!adminId) {
                toast.error('Admin ID not found. Please try logging in again.');
                return;
            }

            this.setState({ loader: true });
            await bulkOnboardJobseekers(adminId, formData);
            if (this.fileInputRef.current) {
                this.fileInputRef.current.value = '';
            }
            this.setState({ loader: false, file: null, source: '', action: 'register' });
            toast.success('Jobseekers onboarded successfully!');
        } catch (err) {
            console.error(err);
            this.setState({ loader: false });
            let msg = 'Some error occurred';
            if (err.response && err.response.data && err.response.data.message) {
                msg = err.response.data.message;
            }
            toast.error(msg);
        }
    }

    render() {
        const { file, source, action, loader, error } = this.state;
        const actionOptions = [
            { id: 'register', name: 'Register' },
            { id: 'update', name: 'Update' }
        ];
        return (
            <div className='jobseeker-bulk-onboard-container'>
                <ToastContainer
                    position='bottom-left'
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className='bulk-onboard-body'>
                    <div className='form-container login-container'>
                        <div className='box-heading'>
                            <h1>Jobseeker Bulk Onboard</h1>
                        </div>
                        <div className='form-fields'>

                            <div className='form-field'>
                                <span className='field-label'>Source *</span>
                                <div className='input-field'>
                                    <InputBox
                                        name='source'
                                        type='text'
                                        value={source}
                                        onChange={this.onSourceChange.bind(this)}
                                    />
                                    {error && error.includes('source') ? (
                                        <span className='validation-error'>{error}</span>
                                    ) : null}
                                </div>
                            </div>

                            <div className='form-field'>
                                <span className='field-label'>Action *</span>
                                <div className='input-field'>
                                    <Dropdown
                                        name='action'
                                        data={actionOptions}
                                        defaultValue={action}
                                        dropdownChange={this.onActionChange.bind(this)}
                                    />
                                </div>
                            </div>

                            <div className='form-field'>
                                <span className='field-label'>File *</span>
                                <div className='input-field'>
                                    <div className='file-selector'>
                                        <input
                                            type='file'
                                            accept='.xlsx'
                                            id='bulk-onboard-file'
                                            ref={this.fileInputRef}
                                            onChange={this.fileChangeHandler.bind(this)}
                                        />
                                        <label htmlFor='bulk-onboard-file' className='file-label'>
                                            {file ? file.name : 'Choose File (.xlsx)'}
                                        </label>
                                    </div>
                                    {error && error.includes('file') ? (
                                        <span className='validation-error'>{error}</span>
                                    ) : null}
                                    {error && error.includes('.xlsx') ? (
                                        <span className='validation-error'>{error}</span>
                                    ) : null}
                                </div>
                            </div>

                        </div>
                        <div className='form-submisstion-field'>
                            <Button
                                text='Submit'
                                skin='dark'
                                clickButton={this.submit.bind(this)}
                                loading={loader}
                                disabled={loader}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
